import Logo from 'Components/Logo'
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const Center = styled.div`
  display: flex;
  justify-content: center;
`
const MaxWidth = styled.div`
  padding: ${({ theme }) => theme.spacing.xLarge};
`

const Spacer = styled.div`
  height: ${({ theme }) => theme.spacing.xLarge};
`

const CookiePolicyContainer: React.FC = () => {
  const policyRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (policyRef.current) window.bfConsent?.renderCookiePolicy(policyRef.current)
  }, [])

  const { t } = useTranslation()

  const openCookieSettings = () => {
    window.bfConsent?.showPreferences()
  }

  return (
    <Center>
      <MaxWidth>
        <Spacer />
        <Logo/>
        <div ref={policyRef}></div>
        <button style={{ textAlign: 'left' }} onClick={openCookieSettings}>{t('cookiesButton.showCookieSettings')}</button>
      </MaxWidth>
    </Center>
  )
}

export default CookiePolicyContainer
